import {
  Group,
  Panel,
  Separator,
  useDefaultLayout,
} from 'react-resizable-panels'

import { ParameterDefinitionTimelineDiagram } from '../../components/parameterTimeline/ParameterDefinitionTimelineDiagram'
import { ParameterValueOperations } from '../../components/parameterValues/ParameterValueOperations'

export const ParameterSidebar = () => {
  const { defaultLayout, onLayoutChanged } = useDefaultLayout({
    groupId: 'parameterSidebar',
    storage: localStorage,
  })
  return (
    <Group
      id="parameterSidebar"
      orientation="vertical"
      defaultLayout={defaultLayout}
      onLayoutChanged={onLayoutChanged}
    >
      <Panel id="parameterDefinitionPanel" minSize="15%" className="p-4">
        <ParameterDefinitionTimelineDiagram />
      </Panel>
      <Separator
        id="resizeParameterPanels"
        className="h-1.5 dark:bg-slate-700 bg-slate-300"
      />
      <Panel id="parameterValuesPanel" minSize="30%">
        <ParameterValueOperations />
      </Panel>
    </Group>
  )
}
